import React from 'react'
import Loading from './Loading'
import { Navigate } from 'react-router-dom';


const Site = () => {

    if (localStorage.getItem("year") === null) {
        return <Navigate to="/" />
    }

    const link = localStorage.getItem('finallink')


    return (
        <>
            <Loading link={link} />
            <div style={{ height: '100vh' }}>
                <iframe allowTransparency="false" id="iframe" src={link} title="myFrame" width="100%" style={{ height: '100vh', maxWidth: '100%', minWidth: '640px' }}>
                    <p>Your browser does not support iframes.</p>
                </iframe>
            </div>


        </>
    )
}

export default Site
